import AutocompleteFieldInternal, {
  componentName,
} from './AutocompleteFieldInternal';

customElements.define(componentName, AutocompleteFieldInternal);
